import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import AuthMainLayout from './components/layout/AuthMainLayout';
import GlobalLoader from './components/common/GlobalLoader';

// Landing Page
import Landing from './components/pages/landing';
import Subscriptions from './components/pages/landing/plans';

// Auth Pages
import Login from './components/pages/auth/Login';
import WaitingForReview from './components/pages/auth/WaitingForReview';
import Register from './components/pages/auth/Register';
import ForgotPassword from './components/pages/auth/ForgotPassword';
import OTPVerification from './components/pages/auth/OTPVerification';
import ResetPassword from './components/pages/auth/ResetPassword';
import SetNewPassword from './components/pages/auth/NewPassword';

// Payment
import MakePayment from './components/pages/payment/MakePayment';

// Screens
import EventsList from './components/pages/events/List';
import EventsDetails from './components/pages/events/Details';
import LocationsList from './components/pages/locations/List';
import LocationsDetails from './components/pages/locations/Details';
import Profile from './components/pages/profile/Profile';
import Account from './components/pages/account/Account';
import FAQ from './components/pages/common/FAQ';
import Terms from './components/pages/common/Terms';
import Privacy from './components/pages/common/Privacy';
import ContactForm from './components/pages/common/ContactForm';
import { useEffect } from 'react';
import DeleteAccount from './components/pages/account/DeleteAccount';

const App = () => {

  useEffect(() => {
    if(localStorage.getItem("isShowTour") == null) {
      localStorage.setItem("isShowTour", "true");
    }
  }, [localStorage.getItem("isShowTour")])

  return (
    <>
      <GlobalLoader />
      <Routes>
        {/* Landing Page */}
        <Route path="/lander" element={<Landing />} />
        <Route path="/delete-account" element={<DeleteAccount/>} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        {/* Auth Routes */}
        <Route element={<AuthMainLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/waiting-for-review" element={<WaitingForReview />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/otp-verification/:email" element={<OTPVerification />} />
          <Route path="/reset-password/:email/:otp" element={<ResetPassword />} />
          <Route path="/generate-password/:company_id" element={<SetNewPassword />} />
        </Route>

        {/* Protected Routes */}
        <Route element={<MainLayout />}>
          <Route path="/make-payment/:_id/:user_id/:type/:entity/:actionType/:prod_id" element={<MakePayment />} />
          {/* Event Routes */}
          <Route path="/events">
            <Route path="list" element={<EventsList />} />
            <Route path="details/:_id" element={<EventsDetails />} />
            
          </Route>
          <Route path="/locations">
            <Route path="list" element={<LocationsList />} />
            <Route path="details/:_id" element={<LocationsDetails />} />
          </Route>
          <Route path="profile" element={ <Profile /> } />
          <Route path="account" element={ <Account /> } />
          <Route path="faqs" element={ <FAQ /> } />
          <Route path="terms" element={ <Terms /> } />
          <Route path="privacy" element={ <Privacy /> } />
          <Route path="contact-form" element={ <ContactForm /> } />
          {/* Redirect to landing page */}
          <Route path="/" element={<Navigate to="/lander" />} />
        </Route>
        {/* Catch-all redirect to / */}
        <Route path="*" element={<Navigate to="/lander" />} />
      </Routes>
    </>
  );
}

export default App;